/*
 * The colors available in the Component Library on Client and Broker side.
 * The interface is used to restrict what colors can be used in the application.
 * These colors will also be used in muiTheme to add custom colors that can be accessed through the theme.
 *
 * NOTE: When adding a new color, make sure to define the hex string in RaiseColors.
 * Link to Figma Components Library - Color
 * https://www.figma.com/file/hKmqc7BQd1bxg9ukv0nUwx/Product?node-id=312%3A0
 */

export var RaiseColors = /*#__PURE__*/function (RaiseColors) {
  RaiseColors["kale"] = "#004241";
  RaiseColors["greenBeans"] = "#00615D";
  RaiseColors["shamrock"] = "#00D49E";
  // Neutrals
  RaiseColors["black"] = "#000000";
  RaiseColors["gray800"] = "#1F2937";
  RaiseColors["gray400"] = "#242B38";
  RaiseColors["gray300"] = "#737882";
  RaiseColors["gray200"] = "#A5A8AD";
  RaiseColors["gray100"] = "#E2E3EA";
  RaiseColors["grayHover"] = "#F2F2F2";
  RaiseColors["grayNav"] = "#FAFAFA";
  RaiseColors["white"] = "#FFFFFF";
  RaiseColors["blue"] = "#0780FF";
  // Accents
  RaiseColors["peach"] = "#FF8075";
  RaiseColors["grape"] = "#7F43FF";
  RaiseColors["bluePeeps"] = "#0780FF";
  RaiseColors["chestnut"] = "#782323";
  RaiseColors["acai"] = "#2E1C61";
  RaiseColors["blueberry"] = "#08397A";
  // Listing Status
  RaiseColors["onMarket"] = "#1D8727";
  RaiseColors["warning"] = "#FFAC48";
  RaiseColors["alarm"] = "#D80000";
  // Marketing
  RaiseColors["mint"] = "#D0EADF";
  /** WorkplaceOS colors (New Design System) **/
  //https://www.figma.com/design/yg7J0qZnn7wX9fLBBYgVdy/%F0%9F%96%BC%EF%B8%8F--Responsive---Design-System?node-id=9171-2096&node-type=instance&m=dev
  // Primary - The primary color palette is used across all the interactive elements such as CTA’s, links, inputs, active states, etc
  RaiseColors["midnightPurple"] = "#060011";
  RaiseColors["royalPurple"] = "#4900E3";
  RaiseColors["royalPurpleHover"] = "#340499";
  RaiseColors["royalPurple100"] = "#EDE4FF";
  RaiseColors["royalPurple500"] = "#783DF4";
  RaiseColors["teal"] = "#2FA0C7";
  RaiseColors["teal100"] = "#D7F8FF";
  RaiseColors["teal500"] = "#4EDDFC";
  RaiseColors["teal700"] = "#17C2E8";
  RaiseColors["pastelPurple"] = "#D6CEFC";
  RaiseColors["secondaryPastelPurple"] = "#F1EBFD";
  RaiseColors["brown500"] = "#BB8A80";
  RaiseColors["brown100"] = "#ECDEDB";
  RaiseColors["rose900"] = "#D44660";
  RaiseColors["rose700"] = "#F56781";
  RaiseColors["rose100"] = "#FFECEF";
  // Neutral - These colors are used as supporting secondary colors in backgrounds, text colors, seperators, modals, etc
  RaiseColors["neutral500"] = "#8D8B99";
  RaiseColors["neutral400"] = "#CBCAD2";
  RaiseColors["neutral300"] = "#E8E7EB";
  RaiseColors["neutral200"] = "#F8F8F9";
  RaiseColors["neutral100"] = "#FFFFFF";
  RaiseColors["jllNeutral900"] = "#8D8B99";
  RaiseColors["jllNeutral700"] = "#CBCAD2";
  RaiseColors["jllNeutral500"] = "#E8E7EB";
  RaiseColors["jllNeutral400"] = "#D4D4D4";
  RaiseColors["jllNeutral300"] = "#F8F8F9";
  RaiseColors["jllNeutral100"] = "#FFFFFF";
  //primary broker
  RaiseColors["midnight"] = "#131E29";
  RaiseColors["jllRed"] = "#E30613";
  //primary client
  RaiseColors["blue1500"] = "#003E51";
  RaiseColors["blue900"] = "#BCDEE6";
  RaiseColors["blue700"] = "#2FA0C7";
  RaiseColors["blue500"] = "#0C7BA1";
  //success
  RaiseColors["success700"] = "#046744";
  RaiseColors["success500"] = "#077F4E";
  RaiseColors["success300"] = "#10D976";
  RaiseColors["success100"] = "#EBFDF4";
  RaiseColors["successBright"] = "#0DAB60";
  // Warning - These colors convey the feeling of caution. Generally used across warning states
  RaiseColors["warning700"] = "#8C0F2E";
  RaiseColors["warning600"] = "#C14701";
  RaiseColors["warning500"] = "#B0133A";
  RaiseColors["warning300"] = "#E37692";
  RaiseColors["warning200"] = "FFF6F1";
  RaiseColors["warning100"] = "#FEF6F8";
  // Destructive - These colors convey an emotion of negativity. Generally used across error states
  RaiseColors["destructive700"] = "#8C0F2E";
  RaiseColors["destructive500"] = "#B0133A";
  RaiseColors["destructive300"] = "#E37692";
  RaiseColors["destructive100"] = "#FEF6F8";
  RaiseColors["orange1500"] = "#8B3301";
  RaiseColors["orange900"] = "#F06F25";
  RaiseColors["orange500"] = "#FFBE99";
  RaiseColors["orange400"] = "#FFC8A9";
  RaiseColors["orange200"] = "#FFEBDF";
  RaiseColors["orange100"] = "#FFF6F1";
  RaiseColors["sand1500"] = "#574D46";
  RaiseColors["sand1400"] = "#89817B";
  RaiseColors["sand900"] = "#C6BAB2";
  RaiseColors["sand400"] = "#E9D0BB";
  RaiseColors["sand200"] = "#F7ECE3";
  RaiseColors["amber1500"] = "#674A00";
  RaiseColors["amber900"] = "#C08B00";
  RaiseColors["amber700"] = "#E3A600";
  RaiseColors["amber400"] = "#FFCE1B";
  RaiseColors["amber200"] = "#FFF9DA";
  RaiseColors["watercourse1500"] = "#035A45";
  RaiseColors["watercourse900"] = "#08A981";
  RaiseColors["watercourse400"] = "#55ECC6";
  RaiseColors["watercourse200"] = "#C9F9ED";
  RaiseColors["science1500"] = "#004D9B";
  RaiseColors["science900"] = "#4F99E4";
  RaiseColors["science400"] = "#B1D8FF";
  RaiseColors["science200"] = "#E2F1FF";
  RaiseColors["ocean1500"] = "#18556B";
  RaiseColors["ocean1200"] = "#3D768A";
  RaiseColors["ocean1400"] = "#3F7486";
  RaiseColors["ocean1000"] = "#ACC7D0";
  RaiseColors["ocean900"] = "#6BA0B1";
  RaiseColors["ocean400"] = "#AEDCEA";
  RaiseColors["ocean200"] = "#E4F6FB";
  RaiseColors["lilac1500"] = "#6D19C1";
  RaiseColors["lilac900"] = "#B17EE5";
  RaiseColors["lilac400"] = "#E2CBF8";
  RaiseColors["lilac200"] = "#F3EBFC";
  RaiseColors["magenta1500"] = "#960372";
  RaiseColors["magenta900"] = "#E664C6";
  RaiseColors["magenta400"] = "#FCC3ED";
  RaiseColors["magenta200"] = "#FFE8F9";
  RaiseColors["lavender1400"] = "#774977";
  RaiseColors["lavender1000"] = "#A677A6";
  RaiseColors["forest1400"] = "#547654";
  RaiseColors["forest900"] = "#B6D0B6";
  RaiseColors["royal1000"] = "#9CB0F1";
  RaiseColors["bahama1200"] = "#09779E";
  RaiseColors["royalBlue"] = "#2245B0";
  RaiseColors["glacier2400"] = "#01151D";
  RaiseColors["glacier2300"] = "#F5F5F5";
  RaiseColors["glacier1100"] = "#0A1E26";
  RaiseColors["glacier900"] = "#8B979B";
  RaiseColors["glacier900_level5"] = "#C5CBCD";
  RaiseColors["glacier600"] = "#B7C0C3";
  RaiseColors["glacier400"] = "#CED5D8";
  RaiseColors["grayscale100"] = "#F6F9FA";
  RaiseColors["grayscale200"] = "#EFEFEF";
  RaiseColors["grayscale300"] = "#D9D9D9";
  RaiseColors["grayscale900"] = "#959595";
  RaiseColors["space1400"] = "#003E51";
  RaiseColors["salem900"] = "#0DAB60";
  RaiseColors["salem100"] = "#EBFDF4";
  RaiseColors["salem1200"] = "#077F4E";
  RaiseColors["crimson1400"] = "#B0133A";
  RaiseColors["crimson100"] = "#FEF6F8";
  RaiseColors["royal1500"] = "#2245B0";
  RaiseColors["royal200"] = "#EAEEFC";
  RaiseColors["amber500"] = "#FFC40A";
  RaiseColors["bahama200"] = "#D2F4FF";
  return RaiseColors;
}({});